<template>
  <div
    class="survey-report"
    v-if="loaded"
  >
    <van-form :readonly="isDisable">
      <div class="blockbar" />
      <van-cell-group>
        <van-field
          v-model="dataForm.houseLocation"
          type="textarea"
          label="查勘房屋地址"
          placeholder="具体的小区、楼栋及门牌号"
          maxlength="100"
        />
      </van-cell-group>

      <div class="blockbar" />
      <van-cell-group>
        <van-field
          v-model="dataForm.houseCategory"
          label="房屋类别"
          placeholder="请选择房屋类别"
          is-link
          readonly
          @click="houseCategoryClick"
        />
        <van-popup
          v-model="houseCategoryShow"
          round
          position="bottom"
        >
          <van-picker
            title="标题"
            show-toolbar
            value-key="optionValue"
            :columns="houseCategory"
            @confirm="onConfirm($event, 'houseCategory')"
            @cancel="houseCategoryShow = false"
          />
        </van-popup>

        <van-field label="房屋户型">
          <template #input>
            <div>
              <div>
                <input
                  class="form__subinput"
                  v-model="dataForm.houseRoomNum"
                  type="tel"
                  @input="inputChange('houseRoomNum', [])"
                  maxlength="2"
                  :readonly="isDisable"
                >卧室
                <input
                  class="form__subinput"
                  v-model="dataForm.houseParlourNum"
                  type="tel"
                  @input="inputChange('houseParlourNum', [])"
                  maxlength="2"
                  :readonly="isDisable"
                >客厅
                <input
                  class="form__subinput"
                  v-model="dataForm.houseRestaurantNum"
                  type="tel"
                  @input="inputChange('houseRestaurantNum', [])"
                  maxlength="2"
                  :readonly="isDisable"
                >餐厅
              </div>
              <div>
                <input
                  class="form__subinput"
                  v-model="dataForm.houseKitchenNum"
                  type="tel"
                  @input="inputChange('houseKitchenNum', [])"
                  maxlength="2"
                  :readonly="isDisable"
                >厨房
                <input
                  class="form__subinput"
                  v-model="dataForm.houseBathroomNum"
                  type="tel"
                  @input="inputChange('houseBathroomNum', [])"
                  maxlength="2"
                  :readonly="isDisable"
                >卫生间
              </div>
            </div>
          </template>
        </van-field>
      </van-cell-group>

      <div class="blockbar" />
      <van-cell-group>
        <van-field
          label="装修进度"
          readonly
        />
      </van-cell-group>
      <van-cell-group>
        <van-field>
          <template #input>
            <div class="checkbox__box">
              <div class="checkbox__title">
                硬装施工
                <span class="sub">(多选)</span>
              </div>
              <van-checkbox-group
                v-model="dataForm.basicDecoration"
                direction="horizontal"
                @change="checkboxChange($event, 'basicDecoration')"
                :disabled="isDisable"
              >
                <template v-for="option in basicDecoration">
                  <van-checkbox
                    style="margin-bottom: 5px"
                    :name="option.optionCode"
                    :key="option.optionCode"
                  >
                    {{ option.optionValue }}
                  </van-checkbox>
                </template>
              </van-checkbox-group>
            </div>
          </template>
        </van-field>

        <van-field
          v-if="hasOtherOptions.basicDecoration"
          v-model="dataForm.basicDecorationSupply"
          label=" "
          placeholder="请输入具体的施工类型"
          maxlength="15"
        />

        <van-field>
          <template #input>
            <div class="checkbox__box">
              <div class="checkbox__title">
                现场情况
              </div>
              <van-checkbox-group
                v-model="dataForm.siteConditions"
                direction="horizontal"
                @change="checkboxChange($event, 'siteConditions')"
                :disabled="isDisable"
              >
                <template v-for="option in siteConditions">
                  <van-checkbox
                    style="margin-bottom: 5px"
                    :name="option.optionCode"
                    :key="option.optionCode"
                  >
                    {{ option.optionValue }}
                  </van-checkbox>
                </template>
              </van-checkbox-group>
            </div>
          </template>
        </van-field>
      </van-cell-group>

      <div class="blockbar" />
      <van-cell-group>
        <van-field>
          <template #input>
            <div class="radio__box">
              <div class="radio__title">调查意见</div>
              <van-row
                type="flex"
                align="center"
              >
                <van-col>1.是否真实装修：</van-col>
                <van-col>
                  <van-radio-group
                    @change="radioChange($event, 'surveyOpinion')"
                    v-model="dataForm.surveyOpinion"
                    direction="horizontal"
                    :disabled="isDisable"
                  >
                    <template v-for="option in surveyOpinion">
                      <van-radio
                        :name="option.optionCode"
                        :key="option.optionCode"
                      >
                        {{ option.optionCode === '01' ? '是' : '否' }}
                      </van-radio>
                    </template>
                  </van-radio-group>
                </van-col>
              </van-row>
            </div>
          </template>
        </van-field>

        <van-field>
          <template #input>
            <div class="radio__box">
              <div class="radio__title">备注</div>
              <van-checkbox-group
                v-model="dataForm.houseLocationConfirm"
                @change="checkboxChange($event, 'houseLocationConfirm')"
                :disabled="isDisable"
              >
                <van-cell-group>
                  <van-cell
                    v-for="(item, index) in houseLocationConfirm"
                    clickable
                    :key="item.optionCode"
                    :title="`${item.optionValue}`"
                    @click="!isDisable && toggle(index)"
                  >
                    <template #right-icon>
                      <van-checkbox
                        v-if="index !== 0"
                        :name="item.optionCode"
                        ref="checkboxes"
                      />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
          </template>
        </van-field>
      </van-cell-group>

      <div class="blockbar" />
      <van-cell-group>
        <van-field>
          <template #input>
            <div class="radio__box">
              <div class="radio__title">查勘人签字</div>
              <div @click="goSignature">
                <div
                  class="signature__pad"
                  v-if="!ossPathUrl"
                >点击此区域签字</div>
                <img
                  class="signature__img"
                  v-else
                  :src="ossPathUrl"
                >
              </div>
            </div>
          </template>
        </van-field>
      </van-cell-group>

      <div class="blockbar" />
      <div
        style="display: flex; margin: 6px 12px"
        v-if="!isDisable"
      >
        <van-button
          type="info"
          round
          size="large"
          @click="save()"
        >保存 </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { getSurveyReport } from '@/common/surveyReport';
import { getAreaTree, saveSurveyReport, riskSurveryTaskDetail } from '@/common/api';
import { cookieSet } from '@/common/cookie';
import jsApi from '@/common/jsApi';

const codes = [
  'houseType',
  'houseCategory',
  'decorationType',
  'basicDecoration',
  'facilityDecoration',
  'electricalDecoration',
  'furnitureDecoration',
  'surveyOpinion',
  'surveyOpinionDetail',
  'siteConditions',
  'houseLocationConfirm'
];
export default {
  name: 'SurveyReport',
  data() {
    return {
      loaded: true, // 等待接口回调完成再渲染页面标签
      houseType: [],
      houseCategory: [],
      decorationType: [],
      basicDecoration: [],
      facilityDecoration: [],
      electricalDecoration: [],
      furnitureDecoration: [],
      surveyOpinion: [],
      surveyOpinionDetail: [],
      siteConditions: [],
      options: [],
      areaTree: [],
      areaShow: false,
      houseTypeShow: false,
      houseCategoryShow: false,
      surveyOpinionDetailShow: false,
      cascaderValue: '',
      dataForm: {
        areaCode: '',
        areaCodeFormat: '',
        budgetAmount: '',
        builtUpArea: '',
        customerName: '',
        decorationCompany: '',
        decorationType: '',
        electricalDecoration: [],
        facilityDecoration: [],
        furnitureDecoration: [],
        basicDecoration: [],
        surveyOpinion: '',
        surveyOpinionDetail: [],
        siteConditions: [],
        houseCategory: '',
        houseType: '',
        decorationTypeBak: [],
        electricalDecorationBak: [],
        facilityDecorationBak: [],
        furnitureDecorationBak: [],
        basicDecorationBak: [],
        surveyOpinionBak: [],
        surveyOpinionDetailBak: [],
        siteConditionsBak: [],
        houseCategoryBak: [],
        houseTypeBak: [],
        houseTypeSupply: '',
        decorationTypeSupply: '',
        basicDecorationSupply: '',
        electricalDecorationSupply: '',
        furnitureDecorationSupply: '',
        surveyOpinionDetailSupply: '',
        houseBathroomNum: '',
        houseLocation: '',
        houseParlourNum: '',
        houseRoomNum: '',
        idNo: '',
        operatorSign: '',
        operatorSignOssPath: '',
        orderNo: '',
        otherInfo: '',
        remark: '',
        houseLocationConfirm: [],
        houseLocationConfirmBak: [],
        taskNo: ''
      },
      ossPathUrl: '', // 签字图片url
      isDisable: true, // 界面禁用，不可编辑
      optionValueList: [
        // 需要显示汉字的
        'houseType',
        'houseCategory'
      ]
    };
  },
  computed: {
    hasOtherOptions() {
      return {
        basicDecoration: this.dataForm.basicDecoration.includes('08'),
        decorationType: this.dataForm.decorationType.includes('04'),
        electricalDecoration: this.dataForm.electricalDecoration.includes('08'),
        furnitureDecoration: this.dataForm.furnitureDecoration.includes('06'),
        surveyOpinionDetail:
          this.dataForm.surveyOpinion === '02' &&
          this.dataForm.surveyOpinionDetail.includes('07')
      };
    },
    houseLocationConfirm() {
      return [
        {
          optionCode: '',
          optionValue: `1、财险客户，本人确定勘查地址为${this.dataForm.houseLocation}。`
        },
        {
          optionCode: '01',
          optionValue: `2、因装修房屋无室号，拍摄对门照片为证。`
        },
        {
          optionCode: '02',
          optionValue: `3、本人确认拍摄地点为${this.dataForm.houseLocation}。`
        },
        {
          optionCode: '03',
          optionValue: `4、本人确认拍摄地点为${this.dataForm.houseLocation}，照片地址和gps定位容差2公里范围内。`
        }
      ];
    }
  },
  activated() {
    const ossPath = localStorage.getItem('operatorSignOssPath') || '';
    const signPicId = localStorage.getItem('operatorSignPicId') || '';
    if (ossPath) {
      this.dataForm.operatorSignOssPath = signPicId; // 保存用id
      this.ossPathUrl = ossPath;
      localStorage.removeItem('operatorSignOssPath');
      localStorage.removeItem('operatorSignPicId');
    }
  },
  watch: {},
  methods: {
    toggle(index) {
      if (index > 0) {
        this.$refs.checkboxes[index - 1].toggle();
      }
    },
    inputChange(field, [max, min]) {
      this.dataForm[field] = this.dataForm[field].replace(
        /^\D*([0-9]\d*\.?\d{0,2})?.*$/g,
        '$1'
      );
      if (min && this.dataForm[field] < min) {
        this.dataForm[field] = min;
      }
      if (max && this.dataForm[field] > max) {
        this.dataForm[field] = max;
      }
    },
    onAreaFinish({ selectedOptions }) {
      this.areaShow = false;
      this.dataForm.areaCodeFormat = selectedOptions
        .map((option) => option.areaName)
        .join('');
    },
    onConfirm($event, field) {
      this[`${field}Show`] = false;
      this.dataForm[field] = $event.optionValue;
      this.dataForm[`${field}Bak`] = $event;
    },
    radioChange($event, field) {
      this.dataForm[`${field}Bak`] = this[field].find(
        (option) => option.optionCode === $event
      );
    },
    checkboxChange($event, field) {
      this.dataForm[`${field}Bak`] = this[field].filter((option) =>
        $event.includes(option.optionCode)
      );
    },
    houseCategoryClick() {
      if (this.isDisable) {
        return;
      }
      this.houseCategoryShow = true;
    },
    houseTypeClick() {
      if (this.isDisable) {
        return;
      }
      this.houseTypeShow = true;
    },
    async getAreaTree() {
      const res = await getAreaTree({});
      if (!res) {
        return;
      }
      const queue = [res.children];
      while (queue.length) {
        const children = queue.shift();
        children.forEach((child) => {
          if (child.children && child.children.length) {
            queue.push(child.children);
          } else {
            delete child.children;
          }
        });
      }
      this.areaTree = res.children;
    },
    async getSurveyOptions() {
      const codeList = await getSurveyReport({ codes });

      if (codeList && codeList.length) {
        codeList.forEach((code) => {
          this[code.code] = code.kvs.map((kv) => {
            return {
              optionCode: kv.key,
              optionField: '',
              optionRemark: '',
              optionValue: kv.value
            };
          });
        });
      }
    },
    getPostForm() {
      const hasOtherOption = [
        'houseType',
        'decorationType',
        'basicDecoration',
        'electricalDecoration',
        'furnitureDecoration',
        'surveyOpinionDetail'
      ];

      const form = { ...this.dataForm };
      // 调查意见为正常装修时不传意见详情字段
      if (form.surveyOpinion !== '02') {
        form.surveyOpinionDetailBak = [];
      }

      codes.forEach((code) => {
        if (code === 'houseLocationConfirm') {
          form[code] = form[`${code}Bak`].map(item => ({ optionCode: item.optionCode }));
        } else {
          form[code] = form[`${code}Bak`];
        }
        delete form[`${code}Bak`];
      });
      hasOtherOption.forEach((option) => {
        if (this.hasOtherOptions[option]) {
          let other;
          if (Array.isArray(form[option])) {
            other = form[option].find((op) =>
              ['其他', '局部改造'].includes(op.optionValue)
            );
          } else {
            other = form[option];
          }
          if (other) {
            other.optionRemark = form[`${option}Supply`];
            delete form[option][`${option}Supply`];
          }
        }
      });
      return form;
    },
    async save() {
      const postForm = this.getPostForm();
      console.log(postForm);
      try {
        await saveSurveyReport(postForm);
        this.$toast('保存成功');
        // todo: 通知外部保存成功
        setTimeout(function() {
          jsApi.closeCurrentWebView();
        }, 2000);
      } catch (error) {}
    },
    goSignature() {
      if (this.isDisable) {
        return;
      }
      // this.$router.push('startSign');
      this.$router.push({
        name: "startSign",
        query: {
          taskNo: this.dataForm.taskNo,
        }
      });

    },
    async getDetail() {
      this.loaded = false;
      try {
        const res = await riskSurveryTaskDetail({ taskNo: this.dataForm.taskNo });
        if (res) {
          Object.keys(res.report).forEach((key) => {
            if (res.report[key]) {
              // 数组类型
              if (Array.isArray(res.report[key])) {
                const result = res.report[key];
                this.dataForm[`${key}Bak`] = result;
                const arr = [];
                result.forEach((item) => {
                  if (item.optionValue === '其他') {
                    this.dataForm[`${key}Supply`] = item.optionRemark;
                  }
                  arr.push(item.optionCode);
                });
                this.dataForm[key] = arr;

                // 字典类型
              } else if (this.isObject(res.report[key])) {
                const result = res.report[key];
                // 需要显示汉字的
                if (this.optionValueList.includes(key)) {
                  this.dataForm[key] = result.optionValue;
                } else {
                  this.dataForm[key] = result.optionCode;
                }
                // 装修类型选择了局部改造
                if (key === 'decorationType' && res.report[key].optionCode === '04') {
                  this.dataForm[`${key}Supply`] = res.report[key].optionRemark;
                }
                this.dataForm[`${key}Bak`] = result;
              } else {
                this.dataForm[key] = res.report[key];
              }
            }
          });
          const taskStatus = res.order.taskStatus;
          if (taskStatus === 'WORK_END') {
            this.isDisable = true;
          } else {
            this.isDisable = false;
          }
          this.ossPathUrl = this.dataForm.operatorSignUrl;
          if (res.order && res.order.contactAddress) {
            this.dataForm.houseLocation = res.order.contactAddress;
          }
        }
      } catch (e) {
        // error Handle
      }
      this.loaded = true;
    },
    isObject(obj) {
      if (Object.prototype.toString.apply(obj) === '[object Object]') {
        return true;
      }
      return false;
    }
  },
  created() {
    localStorage.removeItem('operatorSignOssPath');
    localStorage.removeItem('operatorSignPicId');

    if (this.$route.query.token) {
      let token = this.$route.query.token;
      token = (token || '').replace(/\s/g, '+');
      cookieSet('token', token, {
        domain: window.location.hostname
      });
    }

    if (this.$route.query.taskNo) {
      this.dataForm.taskNo = this.$route.query.taskNo;
    }
    // 房屋地址
    if (this.$route.query.houseLocation) {
      this.dataForm.houseLocation = this.$route.query.houseLocation;
    }

    if (this.$route.query.customerName) {
      this.dataForm.customerName = this.$route.query.customerName;
    }

    // this.getAreaTree(); //省市区，这一期不用
    this.getSurveyOptions();
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.survey-report {
  .blockbar {
    width: 100%;
    height: 12px;

    background-color: #f7f7f7;
  }

  .radio__box {
  }

  .radio__title {
    margin-bottom: 14px;

    .sub {
      color: #c8c8c8;
    }
  }

  .checkbox__box {
  }

  .checkbox__title {
    margin-bottom: 14px;

    .sub {
      color: #c8c8c8;
    }
  }

  .form__subinput {
    width: 30px;

    text-align: center;

    border: none;
    background: white;

    border-bottom: 1px solid;
  }

  .signature__pad {
    display: flex;
    align-items: center;
    justify-content: center;

    width: calc(100vw - 32px);
    height: 150px;

    color: #c8d8eb;
    background-color: #f5f7fa;

    font-size: 16px;
  }

  .signature__img {
    display: flex;

    width: calc(100vw - 32px);
    height: 150px;
  }
}
</style>
